import { useCallback, useMemo } from 'react';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderRemoteCollaboration } from '../../../../hooks/order/useOrderRemoteCollaboration';
import { useOrderContext } from '../../../../providers/OrderProvider';
import { useStatisticsContext } from '../../../../providers/StatisticsProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const AccountsReceivableModal = ({ setIsOpenPendingModal, isOpenPendingModal }) => {
	const { order, isLoading } = useOrderContext();
	const { handleRemoteOrderUpdate } = useOrderRemoteCollaboration('payment', {
		enabled: isOpenPendingModal,
	});
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};
	const { refreshStatisticsAfterOrderChange } = useStatisticsContext();

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
		refreshStatisticsAfterOrderChange();
	}, [setIsOpenPendingModal, refreshStatisticsAfterOrderChange]);

	const paymentStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.payment ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={paymentStatusBadge ? [paymentStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					notesType='pay'
					paymentScheduleModelName='AccountsReceivableModal'
					contractTooltipId='ar-contract-toggle-tooltip'
					invoiceTooltipId='ar-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter onRemoteOrderUpdate={handleRemoteOrderUpdate} />
		</OrderFullscreenModal>
	);
};

export default AccountsReceivableModal;
